import React from "react";
import { TextField } from "@mui/material";
import { FormikProps } from "formik";

import Grid2 from "@mui/material/Grid2"; // استفاده از Grid2

// ساخت schema برای اعتبارسنجی با yup

const BankForm = ({ formik }: { formik: FormikProps<any> }) => {
  return (
    <Grid2 container spacing={1} marginBottom={1} padding={0.8}>
      {/* فیلد شناسه فرم */}
      <Grid2 size={12}>
        <TextField
          {...formik.getFieldProps("name")} // استفاده از ویژگی‌های فرمیک
          label="نام بانک"
          error={formik.touched.name && Boolean(formik.errors.name)}
          helperText={(formik.touched.name && formik.errors.name) as boolean}
          variant="outlined"
          fullWidth
        />
      </Grid2>
    </Grid2>
  );
};

export default BankForm;
